export default "__VITE_ASSET__0dcdeeeb__"